/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { LibraryGapsTable } from '../../../-components/LibraryGapsTable';
import { useLibraryGapsPage } from '../../../-hooks/useLibraryGapsPage';

export const Route = createFileRoute(
  '/management/scoring-templates/(pages)/(list)/gaps/',
)({ component: LibraryGapsPage });

function LibraryGapsPage() {
  const page = useLibraryGapsPage();

  return (
    <PageContainer>
      <LibraryGapsTable page={page} />
    </PageContainer>
  );
}
